"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useColumns = exports.dataCyHeaderCell = exports.COLORED_CELL = void 0;
var _react = require("react");
var _classNames = require("../classNames");
var _colDef = require("../colDef");
var _components = require("../components");
var _Icon = require("@gogame/ui/Icon");
var _Stack = _interopRequireDefault(require("@gogame/ui/Stack"));
var _Tooltip = _interopRequireDefault(require("@gogame/ui/Tooltip"));
var _Typography = _interopRequireDefault(require("@gogame/ui/Typography"));
var _xDataGridPro = require("@mui/x-data-grid-pro");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["field", "type", "width", "resizable", "renderCell"],
  _excluded2 = ["type", "defaultWidth", "getResizedWidth"],
  _excluded3 = ["width"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var EMPTY_ARR = [];
var COLLAPSED_WIDTH = 20;
var CHECKBOX_WIDTH = 40;
var CHECKBOX_WIDTH_WITH_DROPDOWN = 66;
var COLORED_CELL = exports.COLORED_CELL = 'coloredCell';
var dataCyHeaderCell = exports.dataCyHeaderCell = 'DataGrid-header-cell';
var useColumns = exports.useColumns = function useColumns(_ref2) {
  var valueGetter = _ref2.valueGetter,
    _valueFormatter = _ref2.valueFormatter,
    _ref2$order = _ref2.order,
    order = _ref2$order === void 0 ? EMPTY_ARR : _ref2$order,
    _ref2$collapsed = _ref2.collapsed,
    collapsed = _ref2$collapsed === void 0 ? EMPTY_ARR : _ref2$collapsed,
    _ref2$percentage = _ref2.percentage,
    percentage = _ref2$percentage === void 0 ? EMPTY_ARR : _ref2$percentage,
    scaled = _ref2.scaled,
    columns = _ref2.columns,
    coloredRow = _ref2.coloredRow,
    colorGetter = _ref2.colorGetter,
    checkboxSelection = _ref2.checkboxSelection,
    disabledPaddingClassName = _ref2.disabledPaddingClassName,
    defaultColumnWidth = _ref2.defaultColumnWidth,
    getColumnWidthStorage = _ref2.getColumnWidthStorage,
    allPageSelection = _ref2.allPageSelection;
  var groupingColDef = (0, _react.useMemo)(function () {
    var groupingColumnConfig = columns.find(function (_ref3) {
      var groupingColDef = _ref3.groupingColDef;
      return groupingColDef;
    });
    if (groupingColumnConfig) {
      var _types$type;
      var field = groupingColumnConfig.field,
        type = groupingColumnConfig.type,
        width = groupingColumnConfig.width,
        _groupingColumnConfig = groupingColumnConfig.resizable,
        resizable = _groupingColumnConfig === void 0 ? true : _groupingColumnConfig,
        _groupingColumnConfig2 = groupingColumnConfig.renderCell,
        renderCell = _groupingColumnConfig2 === void 0 ? function (params) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.GgGridTreeDataGroupingCell, _objectSpread({}, params));
        } : _groupingColumnConfig2,
        other = _objectWithoutProperties(groupingColumnConfig, _excluded);
      return _objectSpread(_objectSpread({}, other), {}, {
        field: field,
        formatter: _colDef.types === null || _colDef.types === void 0 || (_types$type = _colDef.types[type]) === null || _types$type === void 0 ? void 0 : _types$type.formatter,
        valueFormatter: function valueFormatter(_, row, column, apiRef) {
          return _valueFormatter(row === null || row === void 0 ? void 0 : row[field], row, column, apiRef);
        },
        renderCell: renderCell,
        initialWidth: width,
        width: width,
        resizable: resizable,
        disableColumnMenu: false
      });
    }
  }, [columns]);
  var columnsToRender = (0, _react.useMemo)(function () {
    var unordered = columns.filter(function (_ref4) {
      var actionsColDef = _ref4.actionsColDef,
        field = _ref4.field;
      return !actionsColDef && !order.includes(field);
    });
    var actions = columns.find(function (_ref5) {
      var actionsColDef = _ref5.actionsColDef;
      return actionsColDef;
    });
    var ordered = order.map(function (col) {
      var colConfig = columns === null || columns === void 0 ? void 0 : columns.find(function (config) {
        return config.field === col;
      });
      return colConfig || {
        field: col
      };
    }, []);
    return [].concat(_toConsumableArray(coloredRow ? [{
      field: COLORED_CELL,
      width: 6,
      minWidth: 6,
      headerClassName: disabledPaddingClassName,
      cellClassName: disabledPaddingClassName,
      fixed: true,
      sortable: false,
      resizable: false,
      flex: undefined,
      disableReorder: true,
      disableColumnMenu: true,
      renderHeader: function renderHeader() {
        return null;
      },
      renderCell: function renderCell(_ref6) {
        var row = _ref6.row;
        var color = colorGetter(row);
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Stack["default"], {
          style: {
            background: color,
            height: '100%',
            width: '100%'
          }
        });
      }
    }] : []), _toConsumableArray(checkboxSelection ? [_objectSpread(_objectSpread({}, _xDataGridPro.GRID_CHECKBOX_SELECTION_COL_DEF), {}, {
      fixed: true,
      width: allPageSelection ? CHECKBOX_WIDTH_WITH_DROPDOWN : CHECKBOX_WIDTH,
      minWidth: allPageSelection ? CHECKBOX_WIDTH_WITH_DROPDOWN : CHECKBOX_WIDTH,
      renderHeader: function renderHeader(params) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_xDataGridPro.GridHeaderCheckbox, _objectSpread({
          isHeader: true
        }, params));
      }
    })] : []), _toConsumableArray([].concat(_toConsumableArray(unordered), _toConsumableArray(ordered), _toConsumableArray(actions ? [actions] : [])).map(function (colConfig) {
      var editableCell = colConfig.editableCell,
        groupingColDef = colConfig.groupingColDef,
        configField = colConfig.field,
        width = colConfig.width,
        fixed = colConfig.fixed,
        fixedRight = colConfig.fixedRight;
      var field = configField;
      var column = null;
      if (groupingColDef) {
        field = _xDataGridPro.GRID_TREE_DATA_GROUPING_FIELD;
        column = createColumn({
          field: field,
          width: width,
          defaultWidth: defaultColumnWidth,
          getResizedWidth: getColumnWidthStorage,
          fixed: fixed,
          fixedRight: fixedRight,
          configField: configField
        });
      } else {
        column = createColumn(_objectSpread(_objectSpread(_objectSpread({}, colConfig), field ? {
          field: field
        } : null), {}, {
          defaultWidth: defaultColumnWidth,
          getResizedWidth: getColumnWidthStorage,
          collapsible: true,
          valueGetter: valueGetter,
          valueFormatter: _valueFormatter
        }), {
          resizable: true,
          sortable: true,
          isPercentage: percentage === null || percentage === void 0 ? void 0 : percentage.includes(field),
          isColorScale: scaled === null || scaled === void 0 ? void 0 : scaled.includes(field)
        });
      }
      if (collapsed !== null && collapsed !== void 0 && collapsed.includes(field)) {
        column = collapseColumn(column);
      }
      if (editableCell) {
        var _column = column,
          renderCell = _column.renderCell;
        column.renderCell = function (props) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.EditCellWrapper, _objectSpread({
            renderCell: renderCell
          }, props));
        };
      }
      return column;
    })));
  }, [coloredRow, checkboxSelection, disabledPaddingClassName, columns, order, scaled, collapsed, percentage]);
  return {
    groupingColDef: groupingColDef,
    columnsToRender: columnsToRender
  };
};
function useKeyMemoValue(value, getKeyFn) {
  var _ref = (0, _react.useRef)();
  if (!_ref.current) {
    _ref.current = value;
  } else {
    if (getKeyFn(_ref.current) !== getKeyFn(value)) {
      _ref.current = value;
    }
  }
  return _ref.current;
}
function getKey(_ref7) {
  var left = _ref7.left,
    right = _ref7.right;
  return [].concat(_toConsumableArray(left), _toConsumableArray(right)).join('');
}
function createColumn(_ref8, defaults) {
  var _ref9, _getResizedWidth;
  var _ref8$type = _ref8.type,
    type = _ref8$type === void 0 ? '__custom' : _ref8$type,
    defaultWidth = _ref8.defaultWidth,
    getResizedWidth = _ref8.getResizedWidth,
    def = _objectWithoutProperties(_ref8, _excluded2);
  var _pinnable$defaults$de = _objectSpread(_objectSpread(_objectSpread({
      pinnable: false
    }, defaults), _colDef.types[type] || {}), def),
    width = _pinnable$defaults$de.width,
    mixedDef = _objectWithoutProperties(_pinnable$defaults$de, _excluded3);
  var initialWidth = (_ref9 = typeof width === 'function' ? width(mixedDef) : width) !== null && _ref9 !== void 0 ? _ref9 : defaultWidth;
  var columnWidth = mixedDef.resizable ? (_getResizedWidth = getResizedWidth(mixedDef.field)) !== null && _getResizedWidth !== void 0 ? _getResizedWidth : initialWidth : initialWidth;
  return _objectSpread({
    collapsed: false,
    filterable: false,
    getValue: mixedDef.getValue,
    // for color scale
    width: columnWidth,
    initialWidth: initialWidth,
    configField: mixedDef.field,
    renderHeader: function renderHeader(_ref0) {
      var colDef = _ref0.colDef;
      if (colDef) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography["default"], {
          lineClamp: 2,
          tooltipText: colDef === null || colDef === void 0 ? void 0 : colDef.tooltip,
          "data-cy": dataCyHeaderCell,
          align: colDef.headerAlign,
          variant: 'caption',
          sx: {
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            fontWeight: 'inherit'
          },
          children: colDef === null || colDef === void 0 ? void 0 : colDef.headerName
        });
      }
      return null;
    },
    columnType: type
  }, mixedDef);
}
function collapseColumn(column) {
  return _objectSpread(_objectSpread({}, column), {}, {
    width: COLLAPSED_WIDTH,
    minWidth: COLLAPSED_WIDTH,
    collapsed: true,
    sortable: false,
    resizable: false,
    editable: false,
    flex: undefined,
    disableReorder: true,
    headerClassName: _classNames.COLLAPSED_COLUMN_HEADER,
    cellClassName: _classNames.COLLAPSED_CELL,
    renderHeader: function renderHeader() {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip["default"], {
        title: column.headerName,
        wrapper: true,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.UnfoldMoreIcon, {
          sx: {
            fontSize: 20,
            display: 'block',
            position: 'relative'
          },
          color: 'action'
        })
      });
    },
    renderCell: function renderCell() {
      return null;
    }
  });
}